import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { IImporterBrokerInfo } from '../models/declarations.model';
import { Observable } from 'rxjs';

@Injectable()
export class CadService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  get baseCadUrlBP(): string {
    return `${this.endPointBP}/cad`;
  }

  getImporterBrokerInfo(): Observable<IImporterBrokerInfo> {
    const endPoint = `${this.baseCadUrlBP}/importer-broker-info`;
    return this.httpAuthGet<IImporterBrokerInfo>(endPoint);
  }
}
